import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ReferenceLine,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer } from 'recharts';

export default function Chart({ data, dataKey, currentLimit }) {
  const theme = useTheme();
  return (
    <React.Fragment>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKey} />
          <YAxis  type="number" domain={[0, currentLimit+(currentLimit/10)]} />
          <Tooltip />
          <Bar dataKey="count" fill="#556cd6" />
          <ReferenceLine
            y={currentLimit}
            label={
              {
                value: '月間取得可能投稿件数: ' + currentLimit ,
                position: 'top',
                fontWeight: 'bold'
              }
            }
            stroke="red"
            strokeDasharray="3 3"
            isFront="true"
          />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
